import { AxiosResponse } from "axios"
import ConnectApi from "../baseService"
import { TApiResponse } from "../TApiResponse"
import {
  TSyaryoListGetReq,
  TSyaryoMasterListGetRes,
  TIdoPutReq,
  TTantoChangePutReq,
  TSyaryoMasterListGetReq,
  TSyaryoListGetRes,
  TSyaryoMasterGetRes,
  TSyaryoMasterPostReq,
  TSyaryoMasterPutReq,
  TSyaryoMasterTrailerPutReq,
} from "./TSyaryo"

/**
 * 車輌に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class SyaryoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyaryoListGetReq} params
   * @param {(param: TApiResponse<TSyaryoListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TSyaryoListGetRes>) => any} reject
   * @memberof SyaryoService
   */
  getList = async (params: TSyaryoListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoListGetRes>> =
        await this.getInner(`/master/syaryo`, { 廃車フラグ: 0, ...params })
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * マスタ検索取得
   *
   * @param {TSyaryoMasterListGetReq} params
   * @param {(param: TApiResponse<TSyaryoMasterListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TSyaryoMasterListGetRes>) => any} reject
   * @memberof SyaryoService
   */
  getMasterList = async (
    params: TSyaryoMasterListGetReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoMasterListGetRes>> =
        await this.getInner(`/master/syaryomaster`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 異動 更新
   *
   * @param {TIdoPutReq} data
   * @param {(param: TApiResponse<TSyaryoSyozokuListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TSyaryoSyozokuListGetRes[]>>) => any} reject
   * @memberof SyaryoService
   */
  putIdo = async (id: string, data: TIdoPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truck/syaryosyozokumaster`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 担当 更新
   *
   * @param {TTantoChangePutReq} data
   * @param {(param: TApiResponse<TSyaryoSyozokuListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TSyaryoSyozokuListGetRes[]>>) => any} reject
   * @memberof SyaryoService
   */
  putTanto = async (id: string, data: TTantoChangePutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truck/syaryosyozokumaster`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {id} id
   * @memberof SyaryoService
   */
  get = async (id: string | number) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoMasterGetRes>> =
        await this.getInner(`/master/syaryomaster/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録 車輌マスタ
   *
   * @param {TSyaryoMasterPostReq} data
   * @memberof SyaryoService
   */
  post = async (data: TSyaryoMasterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> =
        await this.postFormDataInner(`master/syaryomaster`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新 車輌マスタ
   *
   * @param {TSyaryoMasterPut} data
   * @memberof KyotenService
   */
  put = async (id: string, data: TSyaryoMasterPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> =
        await this.putFormDataInner(`master/syaryomaster/${id}`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  putTrailer = async (id: string, data: TSyaryoMasterTrailerPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/syaryomaster/Trailer/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
